import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';
import classnames from 'classnames';

import { TitledCard } from 'Components/';
import { RecipeIdSort } from 'Common/GridHelper';

export const UsedOnRecipeTable = (props) => {
  const { recipeData = [], onChange = () => {}, loading = false } = props;

  const [showInactive, setShowInactive] = React.useState(false);
  const [selectedRecipeIds, setSelectedRecipeIds] = React.useState([]);
  const [filteredRecipeData, setFilteredRecipeData] = React.useState(
    recipeData.filter((x) => !x.IsInactive)
  );

  React.useEffect(() => {
    setFilteredRecipeData(
      showInactive ? recipeData : recipeData.filter((x) => !x.IsInactive)
    );
  }, [showInactive, recipeData]);

  React.useEffect(() => {
    onChange(selectedRecipeIds);
    //Converting to a string ensures changes in the array are always detected
  }, [JSON.stringify(selectedRecipeIds)]);

  const columns = [
    {
      Header: (
        <Checkbox
          checked={
            selectedRecipeIds.length === recipeData.length &&
            recipeData.length > 0
          }
          onChange={(e, data) => {
            if (data.checked) {
              var newSelectedRecipeIds = recipeData.map((x) => x.RecipeId);
              setSelectedRecipeIds(newSelectedRecipeIds);
            } else {
              setSelectedRecipeIds([]);
            }
          }}
        />
      ),
      Cell: (row) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={selectedRecipeIds.includes(row.original.RecipeId)}
              onChange={(e, data) => {
                if (data.checked) {
                  const newSelectedRecipeIds = selectedRecipeIds.slice();

                  newSelectedRecipeIds.push(row.original.RecipeId);

                  setSelectedRecipeIds(newSelectedRecipeIds);
                } else {
                  const newSelectedRecipeIds = selectedRecipeIds.filter(
                    (recipeId) => recipeId !== row.original.RecipeId
                  );
                  setSelectedRecipeIds(newSelectedRecipeIds);
                }
              }}
            />
          </div>
        );
      },
      sortable: false,
      resizable: false,
      headerStyle: { marginTop: '.5%' },
      style: { marginTop: '.1%' },
      width: 32,
    },
    {
      Header: 'Recipe Id',
      style: { textAlign: 'left', paddingLeft: '0px' },
      headerStyle: { textAlign: 'left' },
      accessor: 'RecipeId',
      sortMethod: RecipeIdSort,
      width: 120,
      Cell: (row) => {
        return (
          <div
            className={classnames({
              'used-on-recipe-table-inactive-recipe': row.original.IsInactive,
            })}
          >
            {row.original.RecipeId}
          </div>
        );
      },
    },
    {
      Header: 'Recipe Name',
      headerStyle: { textAlign: 'left' },
      accessor: 'RecipeDescription',
      style: { textAlign: 'left', paddingLeft: '0px' },
      Cell: (row) => {
        return (
          <div
            className={classnames({
              'used-on-recipe-table-inactive-recipe': row.original.IsInactive,
            })}
          >
            {row.original.RecipeDescription}
          </div>
        );
      },
    },
  ];
  return (
    <React.Fragment>
      <TitledCard
        title={'Results'}
        rightItem={
          <Checkbox
            toggle
            label="Include Inactive Recipes"
            style={{ marginTop: '3%' }}
            onChange={() => setShowInactive(!showInactive)}
          />
        }
      >
        <ReactTable
          data={filteredRecipeData ? filteredRecipeData : []}
          columns={columns}
          pageSize={10}
          minRows={10}
          showPageSizeOptions={false}
          loading={loading}
        />
      </TitledCard>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/pages/manageingredient/components/UsedOnRecipeTable.js